/**
 * Google Analytics 页面追踪组件
 */

import { usePageTracking } from '../hooks/useAnalytics';

/**
 * 自动追踪页面浏览的组件
 * 放在 Layout 中使用
 */
export function AnalyticsPageTracker() {
  usePageTracking();
  return null; // 不渲染任何内容
}

export default AnalyticsPageTracker;